module.exports = __webpack_public_path__ + "img/tabbar_like@3x.27fb3a20.png";